export const logOut = (successCallback) => {
  fetch(`/users/sign_out`, {
    method: 'DELETE',
  }).then(successCallback);
};

export const signIn = (
  email,
  password,
  rememberMe,
  onSuccess,
  onTwoFactorRequired,
  onError,
  onPasswordlessRequired
) => {
  fetch(`/users/sign_in`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...window.utmInfo,
      user: {
        email: email,
        password: password,
        remember_me: rememberMe ? '1' : '',
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (data.status === '2fa_required') {
        onTwoFactorRequired(data);
      } else if (data.status === 'passwordless_required') {
        if (onPasswordlessRequired) {
          onPasswordlessRequired(data);
        } else {
          onError(['This account uses a sign-in code. Check your email for the code we just sent.']);
        }
      } else {
        if (data.errors) {
          onError(data.errors);
        } else if (data.error) {
          onError([data.error]);
        } else {
          onError(['Invalid email or password. After 10 unsuccessful login attempts you will be locked out.']);
        }
      }
    })
    .catch(() => {
      onError(['We could not reach the server. Please check your connection and try again.']);
    });
};

export const getPendingSignInSession = (token, onSuccess, onError) => {
  fetch(`/auth/sign_in_token/pending_session?token=${encodeURIComponent(token)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (onError) {
        onError([data.error || 'This sign-in session is no longer valid.']);
      }
    })
    .catch(() => {
      if (onError) {
        onError(['Network error. Please check your connection and try again.']);
      }
    });
};

export const updatePendingSignInPhone = (token, phone, onSuccess, onError) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  fetch('/auth/sign_in_token/pending_session/phone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({ token: token, phone: phone }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (onError) {
        onError([data.error || 'Could not update that phone number.']);
      }
    })
    .catch(() => {
      if (onError) {
        onError(['Network error. Please check your connection and try again.']);
      }
    });
};

export const confirmPendingPhoneCode = (token, code, onSuccess, onError) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  fetch('/auth/sign_in_token/pending_session/confirm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({ token: token, code: code }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (onError) {
        onError([data.error || 'Invalid or expired code.']);
      }
    })
    .catch(() => {
      if (onError) {
        onError(['Network error. Please check your connection and try again.']);
      }
    });
};

export const getPendingPhoneDelivery = (token, onSuccess) => {
  fetch(`/auth/sign_in_token/pending_session/delivery?token=${encodeURIComponent(token)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success && onSuccess) onSuccess(data);
    })
    .catch(() => {});
};

export const resendPendingSignInCode = (token, onSuccess, onError) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  fetch('/auth/sign_in_token/pending_session/resend', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({ token: token }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (onError) {
        onError([data.error || 'Could not resend the code.']);
      }
    })
    .catch(() => {
      if (onError) {
        onError(['Network error. Please check your connection and try again.']);
      }
    });
};

export const requestSignInToken = (email, onSuccess, onError) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  fetch(`/auth/sign_in_token/request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({ email: email }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (onError) {
        onError([data.message || 'Could not send sign-in code. Please try again.']);
      }
    })
    .catch(() => {
      if (onError) {
        onError(['Network error. Please check your connection and try again.']);
      }
    });
};

export const verifySignInToken = (code, onSuccess, onError) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  fetch(`/auth/sign_in_token/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({ code: code }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data);
      } else if (onError) {
        onError([data.error || 'Invalid or expired code.']);
      }
    })
    .catch(() => {
      if (onError) {
        onError(['Network error. Please check your connection and try again.']);
      }
    });
};

export const demoSignIn = ({ token, email }) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  return fetch(`/auth/sign_in_token/demo_sign_in`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({ token: token || null, email: email || null }),
  }).then((response) => {
    if (response.status === 404) {
      return { success: false, error: 'Demo sign-in is not available in this environment.' };
    }
    return response.json();
  });
};

export const recoverPassword = (email, onSuccess, onError) => {
  fetch(`/users/password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        email: email,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess();
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        onError(errors);
      }
    });
};

export const resetPassword = (resetPasswordToken, password, onSuccess, onTwoFactorRequired, onError) => {
  fetch(`/users/password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        reset_password_token: resetPasswordToken,
        password: password,
        password_confirmation: password,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else if (data.status === '2fa_required') {
        onTwoFactorRequired(data);
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        onError(errors);
      }
    });
};

export const userUpdate = (updates, onSuccess, onError) => {
  fetch(`/api/v1/user`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        ...updates,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (onSuccess) {
          onSuccess(data.user);
        }
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        onError(errors);
      }
    });
};

// Marks the given callout key (e.g. 'phone_feature') as seen on the server.
// The route validates the key against a server-side whitelist before merging
// it into users.seen_callouts, so it is safe to call directly with any key
// the UI thinks should be recorded.
export const markCalloutSeen = (key, onSuccess, onError) => {
  fetch(`/api/v1/user/seen_callouts/${encodeURIComponent(key)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (onSuccess) onSuccess(data.user);
      } else if (onError) {
        onError(data.errors || { base: ['could not mark callout as seen'] });
      }
    })
    .catch((err) => {
      if (onError) onError({ base: [err?.message || 'network error'] });
    });
};

export const getUser = (id, onSuccess, onError = () => {}) => {
  fetch(`/api/v1/users/${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else {
        onError();
      }
    });
};

export const checkTwoFactorAuthState = () => {
  return fetch(`/auth/verify_otp_session`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error(error);
      return { success: false };
    });
};

export const getProvisioningUri = () => {
  return fetch(`/auth/provision_otp`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error(error);
      return { provisioning_uri: null };
    });
};

export const confirmOtp = (otpCode) => {
  const csrfTag = document.querySelector("meta[name='csrf-token']");
  const csrf = csrfTag ? csrfTag.getAttribute('content') : '';

  const headers = {
    'Content-Type': 'application/json',
  };

  if (csrf) {
    headers['X-CSRF-Token'] = csrf;
  }

  return fetch(`/auth/confirm_otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({
      otp_attempt: otpCode,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('OTP confirmation error:', error);
      return { success: false, error: 'Network error. Please check your connection and try again.' };
    });
};

export const confirmRecoveryCode = (recoveryCode) => {
  const csrf = document.querySelector("meta[name='csrf-token']").getAttribute('content');

  return fetch(`/auth/confirm_recovery_code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
    },
    body: JSON.stringify({
      recovery_code: recoveryCode,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Recovery code confirmation error:', error);
      return { success: false, error: 'Network error. Please check your connection and try again.' };
    });
};
